import React from "react";
import { useSelector } from "react-redux";
import { Check, Sparkles } from "lucide-react";
//test
export const pricingdata = [
  {
    id: 1,
    price: "$4300",
    plan: "Annually",
    start: "A Saving of $200",
    variant: "success",
    button: "success",
    ribbon: true,
    regular_priceID: "price_1RIBpUAPzdvW0Lalw4BcsfGl", // live
    regular_priceIDTest: "price_1RIAmCAPzdvW0LalQraqwTdQ",
    plan_type: "yearly",
    interval: "year",
    actext: [
        {
          "id": 1,
          "act1": "Asset Protection",
          "act2": "Escrow Services",
          "act3": "Unlimited Contract Writing",
          "act4": "Create Payment Plans",
          "act5": "E-Sign Contracts",
          "act6": "Bid on Leads",
          "act7": "Receive Leads from Homeowners/Contractors/Etc.",
          "act8": "Chat with Homeowners",
          "act9": "Get Top Search Results on The Tradesmen's Collective App",
          "act10": "Enhance your scope of work visibility",
          "act11": "Add additional jobs under the same contract",
          "act12": "Manage Jobs and completion rates",
          "act13": "Quick Book Integration"
        }
      
    ],
  },
  {
    id: 2,
    interval: "month",
    oldfirst_priceID: "price_1RINaMAPzdvW0LaljUkSMeVT", // live
    first_priceID: "price_1SVkkEAPzdvW0LalnhaQ6xky", // live
    first_priceIDTest:"price_1SVktAAPzdvW0LalDKujPDyA",
    regular_priceID: "price_1SYfcmAPzdvW0LalSPPAAezy", // live
    regular_priceIDTest:"price_1SYfeQAPzdvW0LaloeEcUHfp",
    price: "$375",
    plan: "Monthly",
    start: "",
    variant: "success",
    firstPayment: "$696",
    button: "success",
    ribbon: true,
    plan_type: "monthly",

    actext: [
      
        {
          "id": 1,
          "act1": "Asset Protection",
          "act2": "Escrow Services",
          "act3": "Unlimited Contract Writing",
          "act4": "Create Payment Plans",
          "act5": "E-Sign Contracts",
          "act6": "Bid on Leads",
          "act7": "Receive Leads from Homeowners/Contractors/Etc.",
          "act8": "Chat with Homeowners",
          "act9": "Get Top Search Results on The Tradesmen's Collective App",
          "act10": "Enhance your scope of work visibility",
          "act11": "Add additional jobs under the same contract",
          "act12": "Manage Jobs and completion rates",
          "act13": "Quick Book Integration"
        }
      
      
    ],
  },
];
interface PricingProps {
  handleCancel: (values: any) => void;
  handleStartTrial: (values: any) => void;
  handleSwitchToYearly: (values: any) => void;
  trialEligible: boolean;
}

const PricingContractor: React.FC<PricingProps> = ({
  handleCancel,
  handleStartTrial,
  handleSwitchToYearly,
  trialEligible,
}) => {
  const userSubscribed = useSelector(
    (state: any) => state.UserProfile.subscribedData
  );

  return (
    <section className="subscription-section subscription-pricing">
      <div className="subscription-section__heading">
        <span>Simple pricing</span>
        <h2>Choose the plan that fits your business</h2>
        <p>{trialEligible ? "Both plans include a 30-day free trial and the complete Contract Builder toolkit." : "Choose monthly or annual billing to restore access to the complete Contract Builder toolkit."}</p>
      </div>
      <div className="subscription-plan-grid">
              {(pricingdata || []).map((elem) => {
                const isSubscribed = userSubscribed?.subscription?.planType === elem.plan_type;
                const isAnnual = elem.plan_type === "yearly";
                const canSwitchToYearly =
                  userSubscribed?.subscription?.status === "active" &&
                  userSubscribed?.subscription?.planType === "monthly" &&
                  isAnnual;
                const yearlySwitchScheduled =
                  canSwitchToYearly && userSubscribed?.pendingPlanChange?.targetPlan === "yearly";
                const features = Object.entries(elem.actext[0])
                  .filter(([key]) => key.startsWith("act"))
                  .map(([, value]) => String(value));

                return (
                  <article className={`subscription-plan ${isAnnual ? "subscription-plan--recommended" : ""}`} key={elem.id}>
                    {isAnnual && <span className="subscription-plan__badge"><Sparkles size={15} /> Best value</span>}
                    <div className="subscription-plan__header">
                      {trialEligible ? <span className="subscription-plan__trial">30 days free</span> : null}
                      <h3>{elem.plan}</h3>
                      <div className="subscription-plan__price"><strong>{elem.price}</strong><span>/{elem.interval}</span></div>
                      <p>{elem.start || "Flexible monthly billing"}</p>
                    </div>
                    <button className="subscription-plan__action" type="button" disabled={yearlySwitchScheduled} onClick={()=>{
                      if(isSubscribed){
                        handleCancel(elem.plan_type)
                      }else if(canSwitchToYearly){
                        handleSwitchToYearly(elem)
                      }else{
                        handleStartTrial(elem)
                      }
                    }}>
                      {isSubscribed
                        ? `Cancel subscription${userSubscribed?.remainingDays ? ` · ${userSubscribed.remainingDays} days left` : ""}`
                        : yearlySwitchScheduled
                        ? "Yearly switch scheduled"
                        : canSwitchToYearly
                        ? "Switch to yearly at renewal"
                        : trialEligible
                        ? "Start my free trial"
                        : "Subscribe now"}
                    </button>
                    <div className="subscription-plan__features">
                      <strong>Everything you need:</strong>
                      {features.slice(0, 6).map((feature) => (
                        <span key={feature}><Check size={17} /> {feature}</span>
                      ))}
                      {features.length > 6 && <small>+ {features.length - 6} more benefits included</small>}
                    </div>
                  </article>
                );
              })}
      </div>
    </section>
  );
};

export default PricingContractor;
